import { giphyDarkCharcoal } from '@giphy/colors'
import { useContext, useState } from 'react'
import { IconButton } from 'ui'
import { Input } from './style'
import { CopilotApiContext } from '../../contexts/api'

type Props = {
    className?: string
}

const CopilotSidebarImportInput = ({ className }: Props) => {
    const { importPresetById } = useContext(CopilotApiContext)
    const [value, setValue] = useState<string>('')

    function onImport() {
        if (!value) return

        importPresetById(value)
        setValue('')
    }

    return (
        <Input
            className={className}
            color={giphyDarkCharcoal}
            placeholder="Enter Preset ID"
            selectOnFocus
            size="medium"
            value={value}
            onChange={setValue}
            onEnterKeyPress={() => onImport()}
        >
            <IconButton
                disabled={!value}
                gradient="purple-indigo"
                icon="add"
                size="medium"
                onClick={() => onImport()}
            />
        </Input>
    )
}

export default CopilotSidebarImportInput
